// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChannelSelectController from "./channel_select_controller"
application.register("channel-select", ChannelSelectController)

import DatalistController from "./datalist_controller"
application.register("datalist", DatalistController)

import PostalCodeTriageController from "./postal_code_triage_controller"
application.register("postal-code-triage", PostalCodeTriageController)

import SanitizerController from "./sanitizer_controller"
application.register("sanitizer", SanitizerController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
